import { render, staticRenderFns } from "./ReferralsList.vue?vue&type=template&id=e2cb0d06&"
import script from "./ReferralsList.vue?vue&type=script&lang=ts&"
export * from "./ReferralsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports